import { FeatureName, useIsFeatureEnabled } from '@gripp/shared-logic';
import { Text } from 'react-native-paper';
import { StatusTag } from '../crop-circle/Components/Tag';
import { HeaderStyles } from './headerTypes';

export const SubHeaderText = ({ children }: { children: React.ReactNode }) => {
  const isCropCircleRedesignEnabled = useIsFeatureEnabled(
    FeatureName.CropCircleRedesign
  );

  if (!isCropCircleRedesignEnabled) {
    return <Text style={HeaderStyles.headerText}>{children}</Text>;
  }
  return <StatusTag text={`${children}`} variant="neutral" />;
};
